import React from 'react';
import PropTypes from 'prop-types';

import { CLASS_NAME, SUMMARY_LABELS } from './constants';
import './service_summary.scss';

const ServiceSummary = ({
  cleaningsCount,
  inspectionsCount,
  maintenanceCount,
  checkinsCount,
  checkoutsCount,
  backToBacksCount,
}) => (
  <div className={CLASS_NAME}>
    <div className={`${CLASS_NAME}__row`}>
      <span className={`${CLASS_NAME}__label`}>{SUMMARY_LABELS.CLEANINGS}:</span>
      <span className={`${CLASS_NAME}__value`}>{cleaningsCount}</span>
    </div>

    <div className={`${CLASS_NAME}__row`}>
      <span className={`${CLASS_NAME}__label`}>{SUMMARY_LABELS.INSPECTIONS}:</span>
      <span className={`${CLASS_NAME}__value`}>{inspectionsCount}</span>
    </div>

    <div className={`${CLASS_NAME}__row ${CLASS_NAME}__row--with-spacing`}>
      <span className={`${CLASS_NAME}__label`}>{SUMMARY_LABELS.MAINTENANCE}:</span>
      <span className={`${CLASS_NAME}__value`}>{maintenanceCount}</span>
    </div>

    <div className={`${CLASS_NAME}__row`}>
      <span className={`${CLASS_NAME}__label`}>{SUMMARY_LABELS.CHECKINS}:</span>
      <span className={`${CLASS_NAME}__value`}>{checkinsCount}</span>
    </div>

    <div className={`${CLASS_NAME}__row`}>
      <span className={`${CLASS_NAME}__label`}>{SUMMARY_LABELS.CHECKOUTS}:</span>
      <span className={`${CLASS_NAME}__value`}>{checkoutsCount}</span>
    </div>

    <div className={`${CLASS_NAME}__row`}>
      <span className={`${CLASS_NAME}__label`}>{SUMMARY_LABELS.BACK_TO_BACKS}:</span>
      <span className={`${CLASS_NAME}__value`}>{backToBacksCount}</span>
    </div>
  </div>
);

ServiceSummary.propTypes = {
  cleaningsCount: PropTypes.number,
  inspectionsCount: PropTypes.number,
  maintenanceCount: PropTypes.number,
  checkinsCount: PropTypes.number,
  checkoutsCount: PropTypes.number,
  backToBacksCount: PropTypes.number,
};

ServiceSummary.defaultProps = {
  cleaningsCount: 0,
  inspectionsCount: 0,
  maintenanceCount: 0,
  checkinsCount: 0,
  checkoutsCount: 0,
  backToBacksCount: 0,
};

export default ServiceSummary;
